import { Component, inject } from '@angular/core';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { DynamicFormService } from '@ntap/common';
import {
  Item,
  ItemViewProviderDirective,
  ListViewProviderDirective,
  NtapGlobalConstants
} from '@ntap/core';
import { first, tap } from 'rxjs';

export type CompoundViewUpdatedItemUiState = {
  viewName: string;
  viewData: Item;
};
@Component({
  selector: `app-dodaj-povezana-jedinica-iz-postojece`,
  templateUrl: './dodaj-povezana-jedinica-iz-postojece.component.html'
})
export class DodajPovezaneJediniceGradivaIzPostojecihComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);
  protected dynamicFormService = inject(DynamicFormService);
  protected itemViewProvider = inject(ItemViewProviderDirective);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(jedinice: JedinicaGradiva[]) {
    let id = 0;
    this.listviewProvider.view$
      .pipe(
        first(),
        tap((view) => {
          const parentJedinicaGradivaId = (
            this.listviewProvider.viewState as {
              'en~jedinica_gradiva~id': number;
            }
          )['en~jedinica_gradiva~id'];
          jedinice.forEach((jedinica) => {
            const newItem: any = {
              'rel~jedinica_gradiva_veze~id': id,
              'rel~jedinica_gradiva_veze~url': '',
              'rel~jedinica_gradiva_veze~napomena': '',
              'rel~jedinica_gradiva_veze~entitet_id': parentJedinicaGradivaId,
              'rel~jedinica_gradiva_veze~naziv':
                jedinica['en~jedinica_gradiva~glavni_naziv'],
              'rel~jedinica_gradiva_veze~povezana_jedinica_gradiva_id':
                jedinica['en~jedinica_gradiva~id']
            };

            id--;
            newItem[NtapGlobalConstants.ATTR_$itemType] = view.$mainType;
            this.listviewProvider.addItem(newItem);
            this.listviewProvider.updateItem(newItem, 0);
          });
        })
      )
      .subscribe();

    this.showDialog = false;
  }
}
